import { QNA_ANSWER_TYPE } from '../platform/qnaConstants';

class QnAAnswer {
  constructor({
    id,
    text,
    uid,
    displayName,
    type,
    createdAt,
    tenantId,
    source = 'answers',
  }) {
    this.id = id || null;
    this.text = text || '';
    this.uid = uid || null;
    this.displayName = displayName || 'Anonimen';
    this.type = type || QNA_ANSWER_TYPE.LEGACY;
    this.createdAt = createdAt || null;
    this.tenantId = tenantId || null;
    this.source = source;
  }

  toFirestore() {
    return {
      text: this.text,
      uid: this.uid,
      displayName: this.displayName,
      type: this.type,
      createdAt: this.createdAt,
    };
  }

  static fromFirestore(snapshot, { source = 'answers' } = {}) {
    const data = snapshot.data();
    return new QnAAnswer({
      id: snapshot.id,
      text: data.text,
      uid: data.uid,
      displayName: data.displayName,
      type: data.type || QNA_ANSWER_TYPE.LEGACY,
      createdAt: data.createdAt ? data.createdAt.toDate() : null,
      tenantId: data.tenantId || null,
      source,
    });
  }
}

export default QnAAnswer;
